import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import useCustomer from '@sophocles/hooks/useCustomer';
import ServicePricesGrid from '@sophocles/views/services/components/ServicePricesGrid';

function CustomerServicePriceView(props) {
  const { t } = useTranslation();

  const {
    match: { params },
  } = props;
  const { customerId } = params;

  // Seed the selected-customer slice so the breadcrumb trail names this
  // customer, not whichever one was selected last.
  useCustomer(customerId);

  return (
    <AppNav notFullHeight page={`services_dashboard_prices_${customerId}`}>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', px: 2, pb: 1 }}>
        <TitleBar showBackButton title={t('projectServices.servicePrices.pageTitle')} />
        <ServicePricesGrid customerId={customerId} />
      </Box>
    </AppNav>
  );
}

export default CustomerServicePriceView;
